export const SELECTED_ENTITY = 'SELECTED_ENTITY';
export const USER_ID = 'USER_ID';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const EXPORT_ORDER = 'EXPORT_ORDER';

export const QUICK_START = 'QUICK_START';
